export function apiBaseUrl(): string {
  const fromWindow = typeof window !== 'undefined' ? window.CREDEM_API_BASE_URL : ''
  return (fromWindow || import.meta.env.VITE_CREDEM_BACKEND_URL || '').replace(/\/+$/, '')
}

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const base = apiBaseUrl()
  if (!base) return normalizedPath
  return new URL(normalizedPath, `${base}/`).toString()
}

export function apiAbsoluteUrl(path: string): string {
  const url = apiUrl(path)
  if (/^https?:\/\//i.test(url)) return url
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  return new URL(url, origin).toString()
}

export function brandAssetUrl(filename: 'credem-lockup.png' | 'credem-mark.png' | 'credem-logo.svg'): string {
  const base = import.meta.env.BASE_URL || '/'
  return `${base.replace(/\/?$/, '/')}brand/${filename}`
}
